/**
 * The height a `ResizeObserver` entry occupies in layout, including padding
 * and border.
 *
 * `entry.contentRect.height` is the *content* box, so for an element with
 * `py-2.5 border-b` it under-reports by 21px — padding a sibling by that
 * value leaves it 21px underneath the observed element. `borderBoxSize` is
 * the right measurement; `offsetHeight` covers browsers (and jsdom) that do
 * not populate it, at the cost of integer rounding.
 */
export function observedBorderBoxHeight(entry: ResizeObserverEntry, node: HTMLElement): number {
    const borderBox = entry.borderBoxSize?.[0];
    return borderBox ? borderBox.blockSize : node.offsetHeight;
}
